import React from 'react';
import Navbar from '../Navbar/Navbar';
import "./Footer.css"

const Footer = () => {
  return (
    <footer>
        <Navbar isInHeader = {false}/>
    </footer>
  )
}

export default Footer